import React, { Fragment } from "react"
import { useSelector, useDispatch } from "react-redux"
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Box,
    Button
} from "@material-ui/core"
import LoadingButton from "../../../LoadingButton"
import useStyles from "./styles"
import { openSnackBar } from "../../../../actions/snack-bar"
import { toggleClientInvoiceLogsDialog } from "../../../../actions/billingDialogs"
import { useState } from "react"
import { createSoloCall } from "../../../../actions/solos"
import formatDate from "../../../../utils/formatDate"
import formatNumberWithCommas from "../../../../utils/formatNumberWithCommas"

const ClientInvoiceLogsDialog = () => {
    const classes = useStyles()
    const dispatch = useDispatch()

    const [loading, setLoading] = useState(false)
    const open = useSelector(state => state.billingDialogs.ClientInvoiceLogsDialogOpen)
    const data = useSelector(state => state.billingDialogs.data)
    const { first_name, last_name } = useSelector(state => state.authentication.authenticatedUser)

    const handleClose = () => {
        dispatch(toggleClientInvoiceLogsDialog(false))
    }
    return (
        <Dialog
            open={open}
            PaperProps={{
                classes: {
                    root: classes.dialogPaper,
                },
            }}
        >
            <DialogTitle disableTypography>
                <Typography variant="h3">
                    Payment Adjustment Logs
                </Typography>
            </DialogTitle>
            <DialogContent>

                <Typography variant="h5">
                    Payment Adjustment Logs Timeline
                </Typography>
                <Typography variant="p" style={{ paddingBottom: "10px" }}>
                    Each of the following Payment was made using the Payment Adjustment Feature
                </Typography>

                <Box className={classes.rowWrapper} style={{ paddingTop: "10px" }}>
                    {data && data.length > 0 && data.map((log, index) => (
                        <Fragment>
                            <Box style={{
                                borderBottom: "1px solid #EBEBEB", paddingBottom: "10px", display: 'flex'
                            }}>
                                <Box style={{ width: "70%" }}>
                                    <Typography style={{ fontSize: "16px", fontWeight: 600 }}>
                                        {log.creator_name ? log.creator_name : first_name + " " + last_name}
                                    </Typography>
                                    {/* <Box style={{ display: "flex" }}> */}
                                    <Typography
                                        style={{ fontSize: "14px", fontWeight: 600, textAlign: "left", color: "gray" }}
                                    >
                                        {"Date: "}
                                        <span style={{ color: "black" }}>
                                            {formatDate(log.created_at)}
                                        </span>
                                    </Typography>

                                    {/* <Typography>
                                    {log.creator_name ? log.creator_name : first_name + " " + last_name} had {log.type === "add" ? "credited" : "debited"} $ {log.payment_amount}
                                </Typography> */}

                                    <Typography
                                        style={{ fontSize: "14px", fontWeight: 600, textAlign: "left", color: "gray" }}
                                    >
                                        {"Description: "}
                                        <span style={{ color: "black" }}>
                                            {log.description}
                                        </span>
                                    </Typography>

                                    <Button
                                        size="small"
                                        variant="outlined"
                                        style={{
                                            fontSize: "14px", fontWeight: 600, textAlign: "left",
                                            color: log.type === "add" ? "#77B68A" : "#E0517C",
                                            // color: "#E0517C",

                                            border: "0px solid #EBEBEB",
                                            borderRadius: "5px",
                                            backgroundColor: log.type === "add" ? "#D1EEDB" : "#F7D4DE",
                                            // backgroundColor: "#F7D4DE",

                                        }}
                                    >
                                        {`Amount ${log.type === "add" ? "Credited" : "Debited"}: `}
                                        <span>
                                            {` $ ${log.payment_amount}`}
                                        </span>
                                    </Button>
                                    {/* </Box> */}
                                </Box>



                                <Box mt={1} className={classes.rowWrapper} style={{ borderLeft: "1px solid #EBEBEB", paddingLeft: "20px" }}>
                                    <Box display="flex">
                                        <Typography style={{ fontWeight: 600, color: "#B2B2B2" }}>Deposit:</Typography>
                                        <Typography style={{ fontWeight: 600, textDecoration: "line-through", color: "#B2B2B2" }}>
                                            $ {formatNumberWithCommas(log.previous_deposit)}
                                        </Typography>
                                    </Box>

                                    <Box display="flex">
                                        <Typography style={{ fontWeight: 600 }}>Deposit:</Typography>
                                        <Typography style={{ fontWeight: 600 }}>
                                            $ {formatNumberWithCommas((log.previous_deposit + (log.type === "add" ? parseFloat(log.payment_amount) : -parseFloat(log.payment_amount))))}
                                        </Typography>
                                    </Box>

                                    <Box display="flex">
                                        <Typography style={{ fontWeight: 600, color: "#B2B2B2" }}>Remaining:</Typography>
                                        <Typography style={{ fontWeight: 600, textDecoration: "line-through", color: "#B2B2B2" }}>
                                            $ {formatNumberWithCommas(log.previous_remaining)}
                                        </Typography>
                                    </Box>

                                    <Box display="flex">
                                        <Typography style={{ fontWeight: 600 }}>Remaining:</Typography>
                                        <Typography style={{ fontWeight: 600 }}>
                                            $ {formatNumberWithCommas(log.previous_remaining - (log.type === "add" ? parseFloat(log.payment_amount) : -parseFloat(log.payment_amount)))}
                                        </Typography>
                                    </Box>

                                </Box>
                            </Box>
                        </Fragment>

                    ))}

                </Box>

            </DialogContent>
            <DialogActions className={classes.buttons} styles={{ display: "flex", alignItems: "center" }}>
                <LoadingButton
                    size={window.innerWidth > 600 ? "medium" : "small"}
                    variant="outlined"
                    color="primary"
                    className={classes.button}
                    onClick={handleClose}
                >
                    close
                </LoadingButton>
            </DialogActions>
        </Dialog>
    )
}

export default ClientInvoiceLogsDialog
